import { ChartLineUp } from '@phosphor-icons/react';
import EmptyPage from '../EmptyPage';

function AdminOverviewPage() {
  return (
    <EmptyPage
      title="תמונת מצב"
      icon={ChartLineUp}
      description="כאן תוכלו לראות סטטיסטיקות ונתונים מרכזיים על הקליניקה, כולל ביצועים, תפוסה ומגמות."
    />
  );
}

export default AdminOverviewPage;

